export const Testimonials = () => {
  const data = [
    {
      name: "Rahul",
      text: "I learned full-stack development and got internship with stipend."
    },
    {
      name: "Priya",
      text: "Best place for real-time project experience and career support."
    },
    {
      name: "Karthik",
      text: "Got job opportunity after internship. Highly recommended."
    }
  ];

  return (
    <section className="py-14 text-center">
      <h2 className="text-4xl font-bold mb-12">What Our Students Say</h2>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {data.map((t, i) => (
          <div key={i} className="p-8 border rounded-2xl shadow">
            <p className="mb-4">"{t.text}"</p>
            <h4 className="font-semibold">{t.name}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};